import { analyticsRepository } from "@/repositories/analytics";
import { useStore } from "@/stores/useStore";
import { useCallback } from "react";

const CONTAINER_METRICS_VIEWED_EVENT = "container_metrics_viewed";

export const useContainerMetricsAnalytics = () => {
  const shopId = useStore((s) => s.shopId);

  const logContainerMetricsViewed = useCallback(() => {
    if (!shopId) {
      console.error(
        "Shop ID is missing, cannot log analytics event:",
        CONTAINER_METRICS_VIEWED_EVENT
      );
      return;
    }
    analyticsRepository.logAnalyticsEvent(CONTAINER_METRICS_VIEWED_EVENT, {
      shopId,
    });
  }, [shopId]);

  return { logContainerMetricsViewed };
};
